import { FieldValues } from "react-hook-form";

import React from "react";

import FingridTestGenericInitialForm from "../shared/FingridTestGenericInitialForm";
import TestFcrNPlanningsForm from "./TestFcrNPlanningsForm";
import { TestTypeEnum } from "../shared/types";

const TestFingridFcrN: React.FC = () => {
  const [initialData, setInitialData] = React.useState<FieldValues | null>(null);

  const handleInitialSubmit = (data: FieldValues) => {
    setInitialData(data);
  };

  return !initialData ? (
    <FingridTestGenericInitialForm onSubmit={handleInitialSubmit} testType={TestTypeEnum.fcrN} />
  ) : (
    <TestFcrNPlanningsForm initialData={initialData} />
  );
};

export default TestFingridFcrN;
